/**
 * Copyright IBM Corp. 2022, 2026
 */

import { Suspense } from 'react'
import { Button } from '@hashicorp/mds-react'
import s from './style.module.css'

interface TiktokOEmbed {
	version: string
	type: string
	title: string
	author_url: string
	author_name: string
	width: string
	height: string
	html: string
	thumbnail_width: number
	thumbnail_height: number
	thumbnail_url: string
	provider_url: string
	provider_name: string
}

export default async function TiktokEmbed({ url }) {
	const res = await fetch(`https://www.tiktok.com/oembed?url=${url}`, {
		method: 'GET',
	})
	const embedData: TiktokOEmbed = await res.json()

	return (
		<div className={s.tiktokEmbed}>
			<Suspense
				fallback={
					<div className={s.fallback}>
						<Button
							type="button"
							href={url}
							isHrefExternal={true}
							text="Visit Tiktok post"
							icon="external-link"
							iconPosition="trailing"
							color="secondary"
						/>
					</div>
				}
			>
				<div dangerouslySetInnerHTML={{ __html: embedData.html }} />
			</Suspense>
		</div>
	)
}
